// extracted by mini-css-extract-plugin
export var fadeIn = "_94-0";